var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kw",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h496v496H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 165.3h992.1v165.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31830",
    d: "M0 330.7h992.1v165.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d941",
    d: "M0 0h992.1v165.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v496l247.5-165.3.5-165.5L0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKw);
export default __webpack_public_path__ + "static/media/kw.ea63e7b60e4d193283d87ec61b854850.svg";
export { ForwardRef as ReactComponent };